import styled from 'styled-components';

export const CategoryBanner = styled.div`
  height: auto;
  width: 100%;
  position: relative;
  display: block;
  padding-top: ${(props) => (props.L1Page ? '25%' : '14.2%')};
  // z-index: 1;
  @media (max-width: 720px) {
    padding-top: ${(props) => (props.L1Page ? '75%' : '22.22%')};
  }
  .carousel-desktop {
    display: block !important;
    @media (max-width: 720px) {
      display: none !important;
    }
  }
  .carousel-mobile {
    display: none !important;
    @media (max-width: 720px) {
      display: block !important;
    }
  }
`;

export const CategoryHeading = styled.div`
  color: #000000a6;
  font-weight: 700;
  padding: 12px 18px;
  font-size: 18px;
  @media (min-width: 720px) {
    display: none;
  }
`;

export const CategoryBannerCover = styled.div``;
